<div class="as-dialog-container">
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>
  <mat-label class="as-roboto-slab as-font-24 as-font-bold">
    {{ data.text.title | translate }}
  </mat-label>
  <br /><br />
  @if (data.address) {
    <mat-label class="as-font-14">
      @if (data.address.tag) {
        <p class="as-font-bold">
          {{ 'ADDRESSES.place' | translate }}
        </p>
      }
      {{ data.address.tag }}
      <p class="as-font-bold">{{ 'ADDRESSES.address' | translate }}:</p>
      {{ data.address.detail }}
    </mat-label>
  }
  @if (data.object) {
    <mat-label class="as-font-14">
      {{ data.text.description | translate
      }}{{
      data.object.tag
      ? data.object.tag
      : data.object.brand.toUpperCase() +
      ' **** ' +
      data.object.card_last_numbers
      }}"?
    </mat-label>
  }
  @if (!data.object) {
    <mat-label class="as-font-14">
      {{ data.text.description | translate }}
    </mat-label>
  }
  <br /><br /><br />
  <div class="as-row as-justify-sb">
    <button mat-flat-button color="accent" (click)="accept()">
      <mat-label class="as-font-white">
        {{ data.text.accept | translate }}
      </mat-label>
    </button>
    <button mat-stroked-button color="accent" mat-dialog-close>
      <mat-label class="as-font">
        {{ data.text.cancel | translate }}
      </mat-label>
    </button>
  </div>
</div>
